import React from 'react'
import { getClassNameModern } from '../../../../../../Shared/Frontend/utils/getClassNameFromStyle'
import { jotformBlockClasses } from './jotformBlock.style'
import { slugify } from '../../../../../../Shared/Frontend/utils/slugify'
import { htmlDecode } from '../../../utils/html'

export const JotformBlockLayout = (props: {
  label?: string
  title?: string
  intro?: string
  children?: React.ReactNode
}) => {
  const { label, title, intro, children } = props
  return (
    <div className={getClassNameModern(jotformBlockClasses, 'inner', 'mw-container-s mx-auto px-gutter')}>
      {(label || title || intro) && (
        <header className={getClassNameModern(jotformBlockClasses, 'header', '')}>
          {label && (
            <p className={getClassNameModern(jotformBlockClasses, 'label', 'fs-6 text-primary text-uppercase')}>
              {label}
            </p>
          )}
          {title && <h2 id={slugify(htmlDecode(title))} className={getClassNameModern(jotformBlockClasses, 'title', 'h2 mb-3')}>{title}</h2>}
          {intro && (
            <div
              className={getClassNameModern(jotformBlockClasses, 'intro', 'text--styled lead mb-3')}
              dangerouslySetInnerHTML={{ __html: intro }}
            />
          )}
        </header>
      )}

      <div className={getClassNameModern(jotformBlockClasses, 'content', '')}>{children}</div>
    </div>
  )
}
